export * from './ProductDetailsCardCarousel.tsx';
